;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:propstrata-app":true});}catch(e){}}();import {
	TOUR_TARGETS,
	tourSelector,
} from "@/features/onboarding-tours/orchestrator/tour-target-ids";
import { isTourTargetVisible } from "@/features/onboarding-tours/orchestrator/wait-for-tour-target";
import type { TourStepEffect } from "@/features/onboarding-tours/types/tour-definition";
import { emitter } from "@/lib/emitter";

export function openAddDashboardViewDialog(): void {
	const dialogOpen =
		document.querySelector<HTMLElement>(
			`#${TOUR_TARGETS.addDashboardViewGrid}`,
		) ??
		document.querySelector<HTMLElement>(
			`#${TOUR_TARGETS.addDashboardViewFooter}`,
		);
	if (dialogOpen) {
		return;
	}

	emitter.emit("settings.workspace.dashboards.create", {
		state: "on",
		tourOrigin: true,
	});
}

export function closeAddDashboardViewDialog(): void {
	emitter.emit("settings.workspace.dashboards.create", {
		reason: "tour-navigation",
		state: "off",
	});
}

export function openShareViewDialog(): void {
	if (
		isTourTargetVisible({
			target: tourSelector(TOUR_TARGETS.shareDialogCreate),
		}) ||
		isTourTargetVisible({
			target: tourSelector(TOUR_TARGETS.shareDialogAccessControl),
		})
	) {
		return;
	}

	emitter.emit("share.view.dialog", { state: "on", tourOrigin: true });
}

export function openShareCreate(): void {
	if (
		isTourTargetVisible({
			target: tourSelector(TOUR_TARGETS.shareDialogAccessControl),
		})
	) {
		return;
	}

	if (
		!isTourTargetVisible({
			target: tourSelector(TOUR_TARGETS.shareDialogCreate),
		})
	) {
		openShareViewDialog();
	}

	const createButton = document.querySelector<HTMLElement>(
		`#${TOUR_TARGETS.shareDialogCreate}`,
	);
	if (
		createButton &&
		isTourTargetVisible({
			target: tourSelector(TOUR_TARGETS.shareDialogCreate),
		})
	) {
		createButton.click();
	}
}

export function closeShareViewDialog(): void {
	emitter.emit("share.view.dialog", {
		reason: "tour-navigation",
		state: "off",
	});
}

export function openLeaderboardConfiguration(): void {
	if (
		isTourTargetVisible({
			target: tourSelector(TOUR_TARGETS.leaderboardConfigDialog),
		})
	) {
		return;
	}

	const configButton = document.querySelector<HTMLElement>(
		`#${TOUR_TARGETS.leaderboardConfigButton}`,
	);
	if (
		configButton &&
		isTourTargetVisible({
			target: tourSelector(TOUR_TARGETS.leaderboardConfigButton),
		})
	) {
		configButton.click();
		return;
	}

	emitter.emit("leaderboard.configuration", { state: "on", tourOrigin: true });
}

export function closeLeaderboardConfiguration(): void {
	emitter.emit("leaderboard.configuration", {
		reason: "tour-navigation",
		state: "off",
	});
}

export function openInviteMembersSheet(): void {
	emitter.emit("settings.workspace.users.invite.create", {
		state: "on",
		tourOrigin: true,
	});
}

export function closeInviteMembersSheet(): void {
	emitter.emit("settings.workspace.users.invite.create", {
		reason: "tour-navigation",
		state: "off",
	});
}

export function openCreateDataProviderDialog(): void {
	if (
		isTourTargetVisible({
			target: tourSelector(TOUR_TARGETS.createDataProviderDialog),
		}) ||
		isTourTargetVisible({
			target: tourSelector(TOUR_TARGETS.createDataProviderPicker),
		}) ||
		isTourTargetVisible({
			target: tourSelector(TOUR_TARGETS.createDataProviderCredentialsSection),
		})
	) {
		return;
	}

	const guardConnectButton = document.querySelector<HTMLElement>(
		`#${TOUR_TARGETS.visualizationGuardConnect}`,
	);
	if (
		guardConnectButton &&
		isTourTargetVisible({
			target: tourSelector(TOUR_TARGETS.visualizationGuardConnect),
		})
	) {
		guardConnectButton.click();
		return;
	}

	const addDataProviderButton = document.querySelector<HTMLElement>(
		`#${TOUR_TARGETS.addDataProviderButton}`,
	);
	if (
		addDataProviderButton &&
		isTourTargetVisible({
			target: tourSelector(TOUR_TARGETS.addDataProviderButton),
		})
	) {
		addDataProviderButton.click();
		return;
	}

	emitter.emit("settings.workspace.data_provider.create", {
		state: "on",
		tourOrigin: true,
	});
}

export function closeCreateDataProviderDialog(): void {
	emitter.emit("settings.workspace.data_provider.create", {
		reason: "tour-navigation",
		state: "off",
	});
}

export function closeEditDashboardViewDialog(): void {
	emitter.emit("settings.workspace.dashboards.edit", {
		data: { view: null },
		reason: "tour-navigation",
		state: "off",
	});
}

export function openEditDashboardViewDialog(): void {
	const editSheet = document.querySelector<HTMLElement>(
		`#${TOUR_TARGETS.editDashboardViewSheet}`,
	);
	if (editSheet) {
		return;
	}

	const editButton = document.querySelector<HTMLElement>(
		`#${TOUR_TARGETS.editDashboardViewButton}`,
	);
	editButton?.click();
}

export function closeDeleteDataProviderDialog(): void {
	emitter.emit("settings.workspace.data_provider.delete", {
		data: { providerId: null },
		reason: "tour-navigation",
		state: "off",
	});
}

export function openDataProviderDeleteDialog(): void {
	if (
		isTourTargetVisible({
			target: tourSelector(TOUR_TARGETS.dataProviderDeleteConfirm),
		}) ||
		isTourTargetVisible({
			target: tourSelector(TOUR_TARGETS.dataProviderDeleteSubmit),
		})
	) {
		return;
	}

	const providerCard = document.querySelector<HTMLElement>(
		`#${TOUR_TARGETS.dataProviderCard}`,
	);
	providerCard?.dispatchEvent(
		new MouseEvent("mouseenter", { bubbles: true, cancelable: true }),
	);

	const deleteButton = document.querySelector<HTMLElement>(
		`#${TOUR_TARGETS.dataProviderDelete}`,
	);
	deleteButton?.click();
}

export function closeDeleteDashboardViewDialog(): void {
	emitter.emit("settings.workspace.dashboards.delete", {
		data: { viewId: null },
		reason: "tour-navigation",
		state: "off",
	});
}

export function openDeleteDashboardViewDialog(): void {
	if (
		isTourTargetVisible({
			target: tourSelector(TOUR_TARGETS.deleteDashboardViewConfirm),
		}) ||
		isTourTargetVisible({
			target: tourSelector(TOUR_TARGETS.deleteDashboardViewSubmit),
		})
	) {
		return;
	}

	const deleteButton = document.querySelector<HTMLElement>(
		`#${TOUR_TARGETS.deleteDashboardViewButton}`,
	);
	deleteButton?.click();
}

export function openCreateAutomation(): void {
	if (
		isTourTargetVisible({
			target: tourSelector(TOUR_TARGETS.automationCreateTriggers),
		}) ||
		isTourTargetVisible({
			target: tourSelector(TOUR_TARGETS.automationSourceStep),
		})
	) {
		return;
	}

	const createAnchor = document.querySelector<HTMLAnchorElement>(
		`a#${TOUR_TARGETS.automationsCreateButton}`,
	);
	const createButton = document.querySelector<HTMLElement>(
		`#${TOUR_TARGETS.automationsCreateButton}`,
	);
	const createTarget = createAnchor ?? createButton;
	if (
		createTarget &&
		isTourTargetVisible({
			target: tourSelector(TOUR_TARGETS.automationsCreateButton),
		})
	) {
		createTarget.click();
	}
}

export function runTourStepEffect({
	effect,
}: {
	effect: TourStepEffect;
}): void {
	if (effect === "openLeaderboardConfig") {
		openLeaderboardConfiguration();
		return;
	}

	if (effect === "openInviteMembers") {
		openInviteMembersSheet();
		return;
	}

	if (effect === "openAddDashboardView") {
		openAddDashboardViewDialog();
		return;
	}

	if (effect === "openEditDashboardView") {
		openEditDashboardViewDialog();
		return;
	}

	if (effect === "openShareDialog") {
		openShareViewDialog();
		return;
	}

	if (effect === "openDataProviderDelete") {
		openDataProviderDeleteDialog();
		return;
	}

	if (effect === "openDeleteDashboardView") {
		openDeleteDashboardViewDialog();
		return;
	}

	if (effect === "openCreateDataProvider") {
		openCreateDataProviderDialog();
		return;
	}

	if (effect === "openCreateAutomation") {
		openCreateAutomation();
		return;
	}

	if (effect === "openShareCreate") {
		openShareCreate();
	}
}
